module.exports = __webpack_public_path__ + "img/mt1.ee16dd3e.jpg";